export var cylinder_pos = new Array();
export var smybols_offset_top = 109 + 170 / 2;
cylinder_pos[0] = 131 + 110;
cylinder_pos[1] = 369 + 110;
cylinder_pos[2] = 606 + 110;
cylinder_pos[3] = 844 + 110;

// Animace jednotlivych symbolu + pozice ve sprite
export var icons = {
	"symbol_Bar": {},
	"symbol_Bell": {},
	"symbol_Dollar": {},
	"symbol_Cherry": {},
	"symbol_Joker": {},
	"symbol_Melon": {},
	"symbol_Orange": {},
	"symbol_Plum": {},
	"symbol_Star": {},
};

export var icons_tmp = new Array();

export var symbols = new Array();
symbols[0] = -1;
symbols[1] = -1;
symbols[2] = -1;
symbols[3] = -1;

export var last_symbol = new Array();
last_symbol[0] = -1;
last_symbol[1] = -1;
last_symbol[2] = -1;
last_symbol[3] = -1;

var assetsPath = "assets/";
var imgsPath = assetsPath + "img/";
var audioPath = assetsPath + "audio/"


// Seznam zvuku pro nacteni
var to_load_audio = {


};

function add_wintables_to_load() {
	for(var i = 0; i <= 26; i++) {
		//to_load['winline_' + i] = imgsPath + 'reels/lines/winline_' + i + '_{q}.png';
	}
}

function init_game(dname, config)
{
	// madnes_coins_shift = -80;

	// madnes_show_money_pos_x = wi / 2 - 40;
	// madnes_show_money_pos_y = he / 2 + 20;

	// madnes_show_money_anim_callback_timeout = 40;

	// madnes_set_texture_version(1);

	// madnes_load_init("joker_81", config);

	// madnes_set_ico_size(220, 172 + 7);
	// madnes_set_native_sceen_size(1280, 720);

	// for(var i in to_load_audio)
	// {
	// 	madnes_add_audio(i, to_load_audio[i]);
	// }
	//
	// add_wintables_to_load();
	//
	// for(var i in to_load)
	// {
	// 	madnes_add_to_load(i, to_load[i]);
	// }
	//
    // for(var i in to_load_json)
    // {
    //     if(infotexts_languages.indexOf(lang) === -1)
    //     {
    //         to_load_json[i] = to_load_json[i].replace("{l}", def_lang);
    //     }
	//
    //     madnes_add_json(i, to_load_json[i]);
    // }
	//
	// for(var i in to_load_fonts)
	// {
	// 	madnes_add_font_to_load(i, to_load_fonts[i]);
	// }

	// madnes_set_sprite('_sprite', 216, 172);
	// madnes_set_sprite('_blur', 216, 172);

	// madnes_set_printdesk_function(print_desk);
	// madnes_set_updatedesk_function(print_reels);
	// madnes_set_rotate_function(rotate_run);
	//
	// madnes_set_infomenu_init_function(infomenu_init);
	// madnes_set_infomenu_open_function(infomenu_open);
	// madnes_set_infomenu_close_function(infomenu_close);
	// madnes_set_infomenu_update_function(infomenu_click);
	// madnes_set_infomenu_left_function(infomenu_left);
	// madnes_set_infomenu_right_function(infomenu_right);
	// madnes_set_betmenu_open_function(betmenu_open);

	madnes_set_coin_values_init(function(currency)
	{
		if(currency === "PLN")
		{
			coin_values = [0.1, 1];
		}
		else
		{
			madnes_coin_values_init(currency);
		}
	});

	madnes_set_on_rotate_release(rotate_release);
	madnes_set_on_forcestop_press(forcestop_press);

	madnes_init(dname);
}
